import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Form, Input, Tooltip, Select, Switch } from "antd";
import { LockOutlined, SaveFilled, InfoCircleOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "./UserModal.css"

const UserModal = ({
  isOpen,
  onCancel,
  onSubmit,
  form,
  editingUser,
  areas,
  userRoles
}) => {
  const [passwordRules, setPasswordRules] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });

  const [isActiveSwitch, setIsActiveSwitch] = useState(editingUser?.is_active ?? true);

  useEffect(() => {
    form.setFieldsValue({ is_active: editingUser?.is_active ?? true });
    setIsActiveSwitch(editingUser?.is_active ?? true);
  }, [editingUser, form]);

  const validatePasswordRules = (password) => {
    setPasswordRules({
      length: password.length >= 8 && password.length <= 20,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const RuleCheck = ({ text, checked }) => (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      fontSize: 13,
      fontWeight: 600,
      color: checked ? "#4ED500" : "grey" 
    }}>
      {checked ? <CheckOutlined /> : <CloseOutlined />}
      &nbsp;{text}
    </div>
  );

  return (
    <Modal
      className="dependency-modal"
      title={
        <span>
          <LockOutlined style={{ marginRight: 8 }} />
          {editingUser ? "Editar Usuario" : "Agregar Usuario"}
        </span>
      }
      open={isOpen}
      onCancel={onCancel}
      onOk={() => form.submit()}
      cancelButtonProps={{
        className: 'cancel-button',
      }}
      okButtonProps={{
        className: 'save-type-button',
      }}
      cancelText="Cancelar"
      okText={
        <span>
          <SaveFilled style={{ marginRight: 6 }} />
          Guardar
        </span>
      }
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item name="first_name" label="Nombre" rules={[{ required: true, message: "Campo requerido" }]}>
          <Input maxLength={50} showCount style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="last_name" label="Apellido" rules={[{ required: true, message: "Campo requerido" }]}>
          <Input maxLength={50} showCount style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="username" label="Usuario" rules={[{ required: true, message: "Campo requerido" }]}>
          <Input maxLength={50} showCount style={{ width: '100%' }} />
        </Form.Item>

        {/* {!editingUser && (
          <Form.Item
            name="password"
            label={
              <span>
                Contraseña
                <Tooltip 
                  title={
                    <div>
                      <h4 style={{ marginBottom: 8 }}>La contraseña debe tener:</h4>
                      <RuleCheck text="Tener entre 8 y 20 caracteres" checked={passwordRules.length} />
                      <RuleCheck text="Incluir al menos una letra mayúscula" checked={passwordRules.uppercase} />
                      <RuleCheck text="Incluir al menos una letra minúscula" checked={passwordRules.lowercase} />
                      <RuleCheck text="Incluir al menos un número" checked={passwordRules.number} />
                      <RuleCheck text="Incluir al menos un caracter especial" checked={passwordRules.special} />
                    </div>
                  }
                  overlayStyle={{ maxWidth: 300 }}
                >
                  <InfoCircleOutlined className="custom-icon" />
                </Tooltip>
              </span>
            }
            rules={[
              { required: true, message: "Campo requerido" },
              {
                validator(_, value) {
                  if (
                    passwordRules.length &&
                    passwordRules.uppercase &&
                    passwordRules.lowercase &&
                    passwordRules.number &&
                    passwordRules.special
                  ) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("La contraseña no cumple con los requisitos"));
                },
              },
            ]}
          >
            <Input.Password
              maxLength={20}
              showCount
              style={{ width: '100%' }}
              onChange={(e) => validatePasswordRules(e.target.value)}
            />
          </Form.Item>
        )} */}

        <Form.Item name="area_id" label="Área" rules={[{ required: true, message: "Campo requerido" }]}>
          <Select
            placeholder="Seleccione un área"
            style={{ width: "100%" }}
            options={areas.map(area => ({
              label: area.name,
              value: area.id    
            }))}
          />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Campo requerido" },
            { type: 'email', message: 'Email inválido' },
          ]}
        >
          <Input maxLength={50} showCount type="email" style={{ width: '100%' }} />
        </Form.Item>

        <Row gutter={16}>
          {editingUser && !editingUser.is_superuser && (
            <Col span={18}>
              <Form.Item name="role_id" label="Asignar Rol">
                <Select
                  placeholder="Seleccione un rol"
                  style={{ width: "100%" }}
                  options={userRoles.map(role => ({
                    label: role.name,
                    value: role.id
                  }))}
                />
              </Form.Item>
            </Col>
          )}

          <Col span={6}>
            <Form.Item
              name="is_active"
              label="Estado del Usuario"
              valuePropName="checked"
              style={{ width: '100%' }}
            >
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Switch
  checked={isActiveSwitch}
  onChange={(checked) => {
    setIsActiveSwitch(checked);
    form.setFieldsValue({ is_active: checked });
  }}
  checkedChildren="Activo"
  unCheckedChildren="Inactivo"
  style={{
    backgroundColor: isActiveSwitch ? '#52c41a' : '#ff4d4f',
    width: '100%',
    maxWidth: 120
  }}
/>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>      
    </Modal>
  );
};

export default UserModal;